import React from 'react';
import cn from 'classnames';

import { ReactComponent as UnlockedIcon } from '../../../../src/styles/icon/unlock.svg';
import { ReactComponent as LockedIcon } from '../../../../src/styles/icon/lock.svg';
// import { resetMenuToggled } from '../../../redux/mobileMenuDocs/mobileMenuDocsActions';
import Button from '../../../elements/Button/Button';
import authorize from './AuthorizeBtn.module.scss';

const AuthorizeBtn = ({ isAuthorized, showPopup, onClick, getComponent }) => {
  //must be moved out of button component
  const AuthorizationPopup = getComponent('authorizationPopup', true);

  const handleClick = (e) => {
    e.stopPropagation();
    return onClick();
  };

  return (
    <div className={authorize.authorize__wrapper}>
      <Button className={cn(authorize.authorize__btn)} onClick={handleClick} variant="auth">
        <span>Authorize</span>
        {!isAuthorized ? (
          <UnlockedIcon fill="#fff" width="13" height="14"></UnlockedIcon>
        ) : (
          <LockedIcon fill="#fff" width="13" height="14"></LockedIcon>
        )}
      </Button>
      {showPopup && <AuthorizationPopup />}
    </div>
  );
};

export default AuthorizeBtn;
